<template>
  <div ref="chartDomRef" class="widget"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { debounce } from '@safety/shared-utils'
import * as echarts from 'echarts'

defineExpose({
  resize: function () {
    if (chart.value && !chart.value?.isDisposed()) {
      // chart.value.resize()
      chart.value.dispose()
      chart.value = echarts.init(chartDomRef.value, 'light')
      renderChart()
    }
  }
})

const props = defineProps({ labels: Array, data: Array, title: String })

const color = new echarts.graphic.LinearGradient(0, 1, 0, 0, [
  { offset: 0, color: 'rgba(40, 200, 240, 0.1)' },
  { offset: 1, color: 'rgba(43, 208, 242, 1)' }
])

const chartDomRef = ref(null)
const chart = ref(null)

const getTooltipContent = (params) => {
  const idx = params.dataIndex
  const label = props.labels[idx]
  const name = label?.fullname || label
  const num = Number(props.data[idx])
  const total = props.data.reduce((s, v) => s + Number(v), 0)
  const pct = total ? ((num / total) * 100).toFixed(1) : '0.0'
  return `${name}: ${pct}%`
}

const renderChart = debounce(function () {
  //为了提高性能,使用debounce,导致会延迟执行,此时chart实例可能已经被销毁
  if (!chart.value || chart.value.isDisposed()) return
  chart.value.setOption({
    title: {
      text: props.title,
      textStyle: {
        color: 'white',
        textShadowColor: 'rgba(255, 255, 255, 0.5)',
        textShadowBlur: 15
      },
      left: 'center',
      top: '5%'
    },
    grid: {
      top: '65px',
      bottom: '25px'
    },
    xAxis: {
      type: 'category',
      data: props.labels.map((it) => it.name || it)
    },
    yAxis: {
      show: false
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(0, 24, 72, 0.72)',
      borderColor: 'rgba(0, 148, 208, 0.55)',
      borderWidth: 1,
      textStyle: {
        color: 'rgb(220, 238, 255)'
      },
      axisPointer: {
        type: 'shadow'
      },
      formatter: getTooltipContent
    },
    series: [
      {
        data: props.data,
        type: 'bar',
        label: {
          show: true,
          color: 'rgb(252, 232, 2)',
          position: 'top'
        },
        itemStyle: {
          color: color
        }
      }
    ],
    textStyle: {
      color: 'rgb(99, 158, 216)'
    }
  })
}, 500)

onMounted(() => {
  chart.value = echarts.init(chartDomRef.value, 'light')
  renderChart()
})

onUnmounted(() => {
  chart.value?.dispose()
})

watch([() => props.labels, () => props.data], renderChart)
</script>

<style lang="scss" scoped>
.widget {
  width: 100%;
  height: 100%;
}
</style>
